module.exports = __webpack_public_path__ + "img/xqgg.784152d1.png";